import { render, staticRenderFns } from "./RequestPasswordResetForm.vue?vue&type=template&id=60388163&scoped=true&lang=pug&"
import script from "./RequestPasswordResetForm.vue?vue&type=script&lang=ts&"
export * from "./RequestPasswordResetForm.vue?vue&type=script&lang=ts&"
import style0 from "./RequestPasswordResetForm.vue?vue&type=style&index=0&id=60388163&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60388163",
  null
  
)

export default component.exports